require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2004-02-05-a-sad-day.json") })
        }
      }, "path---articles-2004-02-05-a-sad-day");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2004-02-05-a-sad-day!./.cache/json/articles-2004-02-05-a-sad-day.json
// module id = 344
// module chunks = 231608221292675